import CreditCardIcon from "./SinglePaymentIcons/CreditCardIcon";
import ExtracreditIcon from "./SinglePaymentIcons/ExtracreditIcon";
import PaypalIcon from "./SinglePaymentIcons/PaypalIcon";
import TransferIcon from "./SinglePaymentIcons/TransferIcon";
import SinglePaymentCreditCard from "./SinglePaymentOptions/SinglePaymentCreditCard";

import SinglePaymentPayPal from "./SinglePaymentOptions/SinglePaymentPayPal";
import SinglePaymentTransfer from "./SinglePaymentOptions/SinglePaymentTransfer";
import SinglePaymentCreditCombined from "./SinglePaymentOptions/SinglePaymentCreditCombined";
import { usePayment } from "../Checkout/context/PaymentContext";
import { useEffect, useState } from "react";
import useAccordionScroll from "../../../../hooks/useAccordionScroll";
import localeText from "../../../../locale";

const SinglePaymentAccordionItem = ({
  title,
  isOpen,
  onToggle,
  id,
  toast,
  getPaymentType,
  combinePayment,
  totalPrice,
  disabled = false,
}) => {
  const { currencyProduct, currencyFormat, extracoinInWallet, walletBalanceValue } = usePayment();
  const { accordionRef, scrollToAccordionOnOpen } = useAccordionScroll();

  const [isMdScreen, setIsMdScreen] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMdScreen(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isOpen) {
      scrollToAccordionOnOpen(true, 100);
    }
  }, [isOpen, scrollToAccordionOnOpen]);

  function getIcon(id) {
    switch (id) {
      case 1:
        return <ExtracreditIcon />;
      case 2:
        return <TransferIcon />;
      case 3:
        return <CreditCardIcon />;
      case 4:
        return <PaypalIcon />;
      default:
        return null;
    }
  }

  const renderPaymentType = getPaymentType
    ? getPaymentType(id)
    : (() => {
        switch (id) {
          case 1:
            return (
              <SinglePaymentCreditCombined
                currencyProduct={currencyProduct}
                currencyFormat={currencyFormat}
                extracoinInWallet={extracoinInWallet}
                walletBalanceValue={walletBalanceValue}
                combinePayment={combinePayment}
                totalPrice={totalPrice}
              />
            );
          case 2:
            return (
              <SinglePaymentTransfer
                currencyProduct={currencyProduct}
                currencyFormat={currencyFormat}
                toast={toast}
                combinePayment={combinePayment}
                totalPrice={totalPrice}
              />
            );
          case 3:
            return (
              <SinglePaymentCreditCard combinePayment={combinePayment} totalPrice={totalPrice} />
            );
          case 4:
            return <SinglePaymentPayPal combinePayment={combinePayment} totalPrice={totalPrice} />;
          default:
            return null;
        }
      })();

  return (
    <div
      ref={accordionRef}
      className={`mb-2 card border-round-lg ${disabled ? "opacity-50" : ""} ${
        isMdScreen ? "py-3 px-4" : "py-3 px-3"
      }`}
      style={{
        border: isOpen ? "1px solid #46A748" : "1px solid #d8d8d8",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <div
        className={`w-full flex justify-content-between align-items-center bg-white ${
          disabled ? "cursor-not-allowed" : "cursor-pointer"
        }`}
        onClick={onToggle}
      >
        <span className={`flex align-items-center ${isMdScreen ? "gap-4" : "gap-2"}`}>
          {getIcon(id)}
          <div
            style={{
              color: disabled ? "#999" : "#26235E",
              fontSize: isMdScreen ? "1rem" : "0.75rem",
            }}
          >
            {title}
            {disabled && (
              <small className="block text-gray-500 mt-1">
                ({localeText("methodNotAvailable")})
              </small>
            )}
          </div>
        </span>
        <span className="align-self-center">
          {combinePayment ? (
            <input
              type="checkbox"
              checked={isOpen}
              onChange={onToggle}
              onClick={(e) => e.stopPropagation()}
              disabled={disabled}
              style={{
                width: "18px",
                height: "18px",
                cursor: disabled ? "not-allowed" : "pointer",
                accentColor: "#721AE7",
              }}
            />
          ) : (
            <i
              className={`pi pi-chevron-down transition-transform duration-200 ${
                isOpen ? "transform rotate-180" : ""
              }`}
              style={{ color: "#245AE5" }}
            ></i>
          )}
        </span>
      </div>
      <div
        className={`overflow-hidden ${
          isOpen ? (isMdScreen ? "px-2 pt-4" : "px-1 pt-2") : "max-h-0"
        }`}
      >
        <div style={{ color: "#344563" }}>{renderPaymentType}</div>
      </div>
    </div>
  );
};

export default SinglePaymentAccordionItem;
